import { Component } from '@angular/core';

@Component({
  selector: 'app-indexable-page-layout',
  templateUrl: './indexable-page-layout.component.html',
})
export class IndexablePageLayoutComponent {}
